import React from 'react';
import FullLogo from '../assets/imgs/full-logo.png';
import { Link } from 'react-router-dom';
import SocialMedia from './shared/SocialMedia';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <div className="h-38 bg-[#0D326E] shadow">
      <div className="w-full h-full text-center p-5">
        <Link to="/">
          <img src={FullLogo} alt="logo footer" className="inline-block mb-5 w-52 sm:w-48 md:w-56" />
        </Link>
        <SocialMedia />
        <p className="mt-3 text-white-100">© 2022-{year} Factor K 506, S.A. All Rights Reserved.</p>
      </div>
    </div>
  );
};

export default Footer;
